import { useMutation, useQuery } from "@tanstack/react-query";
import { useToast } from "../../../components/toast/useToast";
import EmailNastaveniService from "./EmailNastaveniService";
import type { EmailConfigStatus, EmailLogEntry, SendTestEmailRequest } from "../generated/models/EmailNastaveni";

// ==========================================
// QUERIES
// ==========================================

export const useEmailConfigStatusQuery = () => {
    return useQuery<EmailConfigStatus, Error>({
        queryKey: ["emailConfigStatus"],
        queryFn: () => EmailNastaveniService.getEmailConfigStatus(),
        staleTime: 60 * 1000,
    });
};

export const useEmailLogQuery = (params?: { limit?: number; offset?: number }) => {
    return useQuery<EmailLogEntry[], Error>({
        queryKey: ["emailLog", params],
        queryFn: () => EmailNastaveniService.getEmailLog(params),
        staleTime: 30 * 1000,
    });
};

// ==========================================
// MUTATIONS
// ==========================================

export const useSendTestEmailMutation = () => {
    const { showToast } = useToast();

    return useMutation<{ success: boolean; message?: string }, Error, SendTestEmailRequest>({
        mutationFn: (data) => EmailNastaveniService.sendTestEmail(data),

        onSuccess: (result) => {
            showToast(result.message || "Testovací e-mail byl odeslán.", "success");
        },

        onError: (error) => {
            showToast(error.message || "Nepodařilo se odeslat testovací e-mail.", "error");
        },
    });
};

// Aktualizace email polí typu kontroly — používej useUpdateTypKontrolyMutation z KontrolyMutations.ts.
// BE má pouze PUT /api/admin/kontroly/typy/{id} s plným TypKontrolyRequest (emailEnabled/emailPredmet/emailTelo/emailIntervaly jsou jeho součástí).
// Volající sestaví celý TypKontrolyRequest (včetně povinných polí kod/nazev/periodaMesicu) a předá jej useUpdateTypKontrolyMutation.
